import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { contractSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useContractForm } from "./useContractForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";
import { StatusTabInput } from "components/status/tabs/input";
import SelectType from "components/select/type";

const ContractForm = ({ defaultProjectId, contractId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead, requiredFields } =
    useContractForm({
      contractId,
      defaultProjectId,
    });

  return (
    <Form
      form={form}
      create={handleCreate}
      read={handleRead}
      update={handleUpdate}
      itemId={contractId || "+"}
      schema={contractSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        isUpdating,
        updateItem,
        isDirty,
      }) => (
        <div className="space-y-6">
          <FormField
            control={form.control}
            name="status"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="contracts"
                  type="form"
                >
                  <FormLabel required={requiredFields.includes(field.name)}>
                    Status
                  </FormLabel>
                  <StatusTabInput {...field} collection="contracts" />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="contracts"
                  field={field.name}
                  type="form"
                >
                  <FormLabel required={requiredFields.includes(field.name)}>
                    Name
                  </FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Type */}
          <FormField
            control={form.control}
            name="type"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:none"}
                  collection="contracts"
                  field={field.name}
                  type="form"
                >
                  <FormLabel required={requiredFields.includes(field.name)}>
                    Type
                  </FormLabel>
                  <SelectType
                    collection="contracts"
                    onValueChange={(val) => field.onChange(val)}
                    {...field}
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
          />
        </div>
      )}
    </Form>
  );
};

export default ContractForm;
